export const RailroadIcon = ({
  color = "#0F2C52",
  size = 20,
}: {
  color?: string;
  size?: number;
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1592_3272)">
        <path
          d="M5.41602 0.635864V19.3859"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.166 0.635864V19.3859"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.29102 3.76086H17.291C17.291 3.76086 17.916 3.76086 17.916 4.38586V7.51086C17.916 7.51086 17.916 8.13586 17.291 8.13586H2.29102C2.29102 8.13586 1.66602 8.13586 1.66602 7.51086V4.38586C1.66602 4.38586 1.66602 3.76086 2.29102 3.76086Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.29102 12.5109H17.291C17.291 12.5109 17.916 12.5109 17.916 13.1359V16.2609C17.916 16.2609 17.916 16.8859 17.291 16.8859H2.29102C2.29102 16.8859 1.66602 16.8859 1.66602 16.2609V13.1359C1.66602 13.1359 1.66602 12.5109 2.29102 12.5109Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1592_3272">
          <rect width="20" height="20" fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
};
